module.exports = {"360924100":"新昌镇","360924101":"澄塘镇","360924102":"棠浦镇","360924103":"新庄镇","360924104":"潭山镇","360924105":"芳溪镇","360924106":"石市镇","360924107":"黄岗镇","360924200":"花桥乡","360924201":"同安乡","360924202":"天宝乡","360924204":"桥西乡","360924400":"宜丰县工业园区","360924500":"车上林场","360924501":"双峰林场","360924502":"石花尖垦殖场","360924503":"黄岗山垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360924.json
// module id = 1435
// module chunks = 0